import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import ToggleSwitch from '../../../../../../common/inputs/toggleSwitch/ToggleSwitch'
import { ContentStateInterface } from '../../../../../../../@types/types'
import { EXTERNAL_INFO_URLS } from '../../../../../../../config'
import { tracking } from '../../../../../../../tracking/tracking'
import { FlowInformation } from '../../../../../../../@types/flow-types'
import { useAppSelectorWithSelected } from '../../../../../../../app/hooks'

export interface HomeStreetHomeProps {
  insertionData: ContentStateInterface
  onChange?: (value: boolean) => void
}

const HomeStreetHome: React.FC<HomeStreetHomeProps> = ({ insertionData, onChange }) => {
  const { isHomeStreetHomeEnabled } = insertionData
  const showHomeStreetHome =
    insertionData.price && +insertionData.price <= 680 && insertionData.livingSpace && +insertionData.livingSpace <= 50

  const { t } = useTranslation()
  const flowInformation = useAppSelectorWithSelected<FlowInformation>((state) => state.flowFeature.flowInformation)
  const [toggleState, setToggleState] = useState(() => isHomeStreetHomeEnabled ?? false)
  useEffect(() => (isHomeStreetHomeEnabled ? setToggleState(true) : undefined), [isHomeStreetHomeEnabled])

  useEffect(() => {
    if (showHomeStreetHome && flowInformation) {
      tracking({ eventName: 'decider_homelesspeople_shown', flowInformation: flowInformation })
    }
  }, [showHomeStreetHome, flowInformation])

  const doToggle = () => {
    setToggleState((prev) => !prev)
    onChange && onChange(!toggleState)
  }
  return showHomeStreetHome ? (
    <div>
      <div className='grid-item margin-bottom-l margin-top-l'>
        <ToggleSwitch
          id='home-street-home'
          className='desk-one-whole'
          alignment='right'
          propertyName='isHomeStreetHomeEnabled'
          label={
            <span className={'font-body-medium-bold'}>
              {t('wizard.screen.description.homeStreetHome.questionText', 'For more information')}
            </span>
          }
          value={isHomeStreetHomeEnabled ?? false}
          onChange={doToggle}
        />
      </div>
      <div>
        {t('wizard.screen.description.homeStreetHome.explanationText', 'explanation for homeless rent')}
        <p className='margin-top-l'>
          {t('wizard.screen.description.homeStreetHome.moreInformationText', 'For more information')}
          <a
            className='link-underline link-text-secondary margin-left-xs'
            target='_blank'
            rel='noopener noreferrer'
            href={EXTERNAL_INFO_URLS.HOME_STREET_HOME}
          >
            {t('linkedHereText', 'here')}
          </a>
        </p>
      </div>
    </div>
  ) : (
    <></>
  )
}

export default HomeStreetHome
